<template>
    <div class="dropdown">
        <a v-if="dropdownTriggerUrl" class="dropdown__trigger" :href="dropdownTriggerUrl">
            <i v-if="icon" class="mdi" :class="icon"></i>
            {{ dropdownTrigger }}
            <i v-if="chevron" class="mdi mdi-chevron-down"></i>
        </a>
        <div v-else class="dropdown__trigger">
            <i v-if="icon" class="mdi" :class="icon"></i>
            {{ dropdownTrigger }}
            <i v-if="chevron" class="mdi mdi-chevron-down"></i>
        </div>
        <ul class="dropdown__content">
            <slot />
        </ul>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
    props: {
        dropdownTrigger: {
            type: String,
        },
        dropdownTriggerUrl: {
            type: String,
        },
        chevron: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
        },
    },
})
export default class Dropdown extends Vue {
    name = 'dropdown';
}

Vue.component('dropdown', Dropdown);
</script>
